<div class="container-fluid">
  <app-header titleText="IDI ADMIN">
  </app-header>
  <div class="card bg-light">
    <div class="card-header">
      <h3>Release Settings</h3>
      <div>
        Release settings define notification message, release note overview and link to release notes document.  It also allows the notification to be turned off or on.
      </div>
      <div class="card-body">
        <div class="form-inline float-right mb-2">
          <div class="float-right">
            <button (click)="showEdit(null)" class="btn btn-bidit-navigate btn-sm">Add</button>
          </div>
        </div>
        <div class="clearfix"></div>
        <div *ngIf="this.dataSource.data.length > 0">
          <mat-table class="table table-bidit table-hover" [dataSource]="this.dataSource">
            <ng-container matColumnDef="releaseSettings_Description">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Description</mat-header-cell>
              <mat-cell *matCellDef="let releaseSettings">
                {{releaseSettings.releaseSettings_Description}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="releaseSettings_NotificationMessage">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Notification Message</mat-header-cell>
              <mat-cell *matCellDef="let releaseSettings">
                {{releaseSettings.releaseSettings_NotificationMessage}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="releaseSettings_Summary">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Summary</mat-header-cell>
              <mat-cell *matCellDef="let releaseSettings">
                {{releaseSettings.releaseSettings_Summary}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="releaseSettings_FileName">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>File Name</mat-header-cell>
              <mat-cell *matCellDef="let releaseSettings">
                {{releaseSettings.releaseSettings_FileName}}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="releaseSettings_ShowNotification">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Show Notification</mat-header-cell>
              <mat-cell *matCellDef="let releaseSettings">
                <mat-checkbox [disabled]="this.lastReleaseId !== releaseSettings.releaseSettings_ID" (change)="checkBoxChanged($event)" class="d-flex align-items-center justify-content-center" [(ngModel)]="releaseSettings.releaseSettings_ShowNotification"></mat-checkbox>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
              <mat-cell class="float-end" *matCellDef="let releaseSettings">
                <a class="btn-bidit-edit-dark ml-4" role="button" (click)="showEdit(releaseSettings.releaseSettings_ID)"></a>
                <button (click)="downloadAttachment(releaseSettings)" class="btn btn-bidit-navigate btn-sm ml-3 mr-1" i18n>Download</button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

          </mat-table>

          <mat-paginator [length]="this.dataSource.data.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

